import { defineComponent, ref } from 'vue'
import { useMainStore } from '@/store/main'

export default defineComponent({
  name: 'AppHeader',
  setup() {
    const mainStore = useMainStore()
    const isMenuOpen = ref(false)
    const isOpenContact = ref(false)
    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value
    }
    const toggleContact = () => {
      isOpenContact.value = !isOpenContact.value
    }
    return {
      mainStore,
      isMenuOpen,
      toggleMenu,
      isOpenContact,
      toggleContact,
    }
  },
})
